import { Router } from '@angular/router';
import { AuthService } from '@app/auth.service';
import { UserService } from '@app/user.service';
var AuthGuard = /** @class */ (function () {
    function AuthGuard(auth, router, user) {
        this.auth = auth;
        this.router = router;
        this.user = user;
    }
    AuthGuard.prototype.canActivate = function (next, state) {
        if (this.auth.isLoggedIn) {
            return true;
        }
        var data = this.user.isLoggedIn();
        if (data.status) {
            this.auth.setLoggedIn(true);
            return true;
        }
        else {
            this.router.navigate(['login']);
            return false;
        }
        // return this.user.isLoggedIn().pipe(map(res => {
        //   if (res.status) {
        //     this.auth.setLoggedIn(true);
        //     return true;
        //   } else {
        //     console.log('logout');
        //     this.router.navigate(['login']);
        //     return false;
        //   }
        // }));
    };
    return AuthGuard;
}());
export { AuthGuard };



// WEBPACK FOOTER //
// ./src/app/auth.guard.ts.pre-build-optimizer.js